export default {
  section: {
    marginBottom: 30,
  },
  hidden: {
    display: 'none',
  },
};
